import { Routes, Route, useLocation } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async';

import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { openLangSelector, openMenuMobile } from './redux';

import './App.css'

import Seo from './layouts/Seo';
import Loader from './layouts/Loader';
import Header from './layouts/Header';
import Lang from './layouts/Lang';
import LayoutWithLang from './layouts/LayoutWithLang';
import AutoLangRedirect from './layouts/AutoLangRedirect';
import Cookies from './layouts/Cookies';
import Footer from './layouts/Footer';

import Home from './pages/Home';
import Error from './pages/Error';
import Illustrations from './pages/Illustrations';
import Works from './pages/Works';
import Work from './pages/Work';
import Planning from './pages/Planning';
import Contact from './pages/Contact';
import Shop from './pages/Shop';
import Articles from './pages/Articles';
import Terms from './pages/Terms';

function App() {
    const dispatch = useDispatch();
    const location = useLocation();

    const headerHeight = useSelector(state => state.options.headerHeight);

    useEffect(() => {
        dispatch(openLangSelector(false));
        dispatch(openMenuMobile(false));
        window.scrollTo(0, 0);
    }, [dispatch, location.pathname]);

    useEffect(() => {
        const handleWheel = (e) => {
            if (e.ctrlKey) e.preventDefault();
        };

        const handleTouchMove = (e) => {
            if (e.touches.length > 1) e.preventDefault();
        };

        document.addEventListener('wheel', handleWheel, { passive: false });
        document.addEventListener('touchmove', handleTouchMove, { passive: false });

        return () => {
            document.removeEventListener('wheel', handleWheel);
            document.removeEventListener('touchmove', handleTouchMove);
        };
    }, []);

    return (
        <HelmetProvider>
            <Seo />
            <Loader />
            <Header />

            <main style={{
                minHeight: `calc(100vh - ${headerHeight}px)`,
                marginTop: `${headerHeight}px`
            }}>
                <Lang />

                <Routes>
                    <Route path="/" element={<AutoLangRedirect />} />

                    <Route path="/:lang" element={<LayoutWithLang />}>

                        <Route index element={<Home />} />
                        <Route path="illustrations" element={<Illustrations />} />

                        <Route path="mangas" element={<Works type={1} />} />
                        <Route path="mangas/:slug" element={<Work />} />

                        <Route path="works" element={<Works type={2} />} />
                        <Route path="works/:slug" element={<Work />} />

                        <Route path="planning" element={<Planning />} />
                        <Route path="contact" element={<Contact />} />

                        <Route path="shop" element={<Shop />} />
                        <Route path="articles/:slug" element={<Articles />} />


                        <Route path="legacy" element={<Terms page="legacy" />} />
                        <Route path="cgv" element={<Terms page="cgv" />} />
                        <Route path="rgpd" element={<Terms page="rgpd" />} />
                        <Route path="copyright" element={<Terms page="copyright" />} />
                        <Route path="cq" element={<Terms page="cq" />} />
                        <Route path="fanart" element={<Terms page="fanart" />} />

                    </Route>

                    <Route path="*" element={<Error />} />
                </Routes>
            </main>

            <Cookies />
            <Footer />
        </HelmetProvider>
    )
}

export default App;